/**
 * Caché local de audio sintetizado (modo audiolibro).
 *
 * Vive en su propia tabla Dexie (`audioCache`, v19) y NO se sincroniza: es
 * binario, enorme (~1 MB por minuto) y de contenido con copyright. Lo que sí
 * viaja entre dispositivos es la posición de escucha, vía el CRDT de
 * progreso que ya existe.
 */
export interface AudioChunkRow {
  /** Clave: ver `audioCacheKey`. */
  id: string
  /** Libro al que pertenece (borrado en cascada y limpieza por libro). */
  bookId: string
  /** Audio sintetizado (mp3). */
  blob: Blob
  /** Tamaño en bytes, desnormalizado para sumar sin leer los blobs. */
  bytes: number
  /** ISO del último uso. Base del desalojo LRU. */
  lastUsedAt: string
}

/**
 * Clave de caché de un fragmento de audio.
 *
 * La **voz** entra en la clave porque cambiarla cambia el audio. La
 * **velocidad** no: se aplica con `audio.playbackRate`, que es gratis y no
 * requiere volver a sintetizar.
 */
export function audioCacheKey(chunkId: string, voice: string): string {
  return `${chunkId}:${voice}`
}
